<script lang="ts">
	import SContent from './Content.svelte';
  	import Modal from 'svelte-simple-modal';
</script>
	
<Modal
  	styleContent={{ maxHeight:"calc(100vh - 1rem)"}}>
	<SContent/>
</Modal>

<style>
</style>